export const getValidPasswordStepsCount = (password) => {
  let validationsCount = 0;

  // Check if the password has at least 13 characters
  if (password.length >= 13) {
    validationsCount++;
  }

  // Check if the password contains at least one uppercase letter
  if (/[A-Z]/.test(password)) {
    validationsCount++;
  }

  // Check if the password contains at least one digit
  if (/\d/.test(password)) {
    validationsCount++;
  }

  // Check if the password contains at least one special character (including backslash and forward slash)
  if (/[!@#$%^&*(),.?":{}|<>/\\]/.test(password)) {
    validationsCount++;
  }

  return validationsCount;
};
